<app-lfsa-card *ngIf="mostrarCard" [innTemplate]="datosRequisicion" [titulo]="'DATOS DE CONSULTA'" [efecto]="true"
  [colapseName]="'datosRequisicion'" [banderaColapse]='true'></app-lfsa-card>
<ng-template #datosRequisicion>

  <div class="row" *ngIf="!listaVacia">
    <div class="'col-md-12'">
      <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscar" id="quickFilter "
        (keyup)="onQuickFilterChanged() " #quickFilter />
    </div>
  </div>

  <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
  <div *ngIf="!loading">
    <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
      No existen datos para la lista de Documentos.
    </div>
    <ag-grid-angular *ngIf="!listaVacia" [class]="empModulo.agGrid.class" 
      [ngStyle]="empModulo.agGrid.style" id="{{empModulo.agGrid.id}}" [frameworkComponents]="frameworkComponents "
      [columnDefs]="columnDefs" [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)"
      [pagination]="true" [paginationPageSize]="empModulo.agGrid.paginacion">
    </ag-grid-angular>
  </div>
  <br>
</ng-template>

<app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
<div *ngIf="!loading" class="row">
  <div class="form-group col-md-12">
    <button [routerLink]="['/emp/sstma/home']"
      class="btn btn-outline-danger btn-block btn-lg">Regresar</button>
  </div>
</div>